import { fetcher } from '@commenda/utils';
import { useMutation } from '@tanstack/react-query';

async function resetTwoFactorRequest(targetUserId: string): Promise<void> {
  const response = await fetcher(`super-admin/user/${targetUserId}/reset-2fa`, {
    method: 'POST',
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { message?: string } | null;
    throw new Error(body?.message ?? 'Failed to reset 2FA. Please try again.');
  }
}

export function useResetTwoFactor() {
  return useMutation({
    mutationFn: resetTwoFactorRequest,
  });
}
